export default __webpack_public_path__ + "static/media/BasicPublic4.2e4757bd.png";